import { AppSwitch } from '@coreui/react';
import NavButton from 'components/navbuttom/NavButton';
import PowerGrid from 'components/powergrid';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Search } from 'react-bootstrap-table2-toolkit';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Col, Label } from 'reactstrap';
import Export from 'utils/export/Export';
import Http from 'utils/http';

const { SearchBar } = Search;
var timer;

class DataGrid extends Component {

  constructor(props) {
    super(props);

    let switchDeleted = DataGrid.getSwitchDeleted();
    if (switchDeleted === null) {
      switchDeleted = this.props.onlyDeleted;
    }

    this.state = {
      isLoading: true,
      onlyDeleted: switchDeleted,
      records: [],
    };

    this.search = {
      searchTextFilter: new Map(),
      searchTextOperation: 'or',
      searchText: ''
    }

    this.options = {
      alwaysShowAllBtns: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: false,
      paginationSize: 5,
      pageStartIndex: 1,
      showTotal: true,
      page: parseInt(sessionStorage.getItem(PowerGrid.pageStorageKey())) || 1,
      sizePerPage: parseInt(localStorage.getItem(PowerGrid.sizePageStorageKey())) || 10,
      totalSize: 0,
      onSizePerPageChange: (sizePerPage, page) => {
        this.onOwnSizePerPageChange(sizePerPage, page);
      },
      onPageChange: (page, sizePerPage) => {
        this.onOwnPageChange(page, sizePerPage);
      }
    }

    let searchText = sessionStorage.getItem(PowerGrid.searchStorageKey()) || '';
    this.search.searchText = searchText;
    this.search.searchTextFilter.set('name', { key: 'name', operation: 'regex', value: searchText });
    this.search.searchTextFilter.set('description', { key: 'description', operation: 'regex', value: searchText });

    this.props.columns.forEach(column => {
      column.onSort = (field, order) => {
        this.onSortGrid(field, order);
      }
    });

  }

  componentDidMount() {
    this.loadData();
  }

  onSortGrid(field, order) {
    let sort = [{
      dataField: field,
      order: order
    }];
    sessionStorage.setItem(PowerGrid.orderStorageKey(), JSON.stringify(sort));

    this.loadData();
  }

  defaultSorted() {
    let sortStorage = sessionStorage.getItem(PowerGrid.orderStorageKey());
    if (sortStorage) {
      return JSON.parse(sortStorage);
    }
    return [{
      dataField: 'name',
      order: 'asc'
    }];
  }

  loadData() {
    const onlyDeleted = DataGrid.getSwitchDeleted();
    const tagFilter = this.props.filter;
    const searchTextFilter = this.search.searchTextFilter;
    const searchOperation = this.search.searchTextOperation;
    const sorts = this.defaultSorted();

    let uri = this.props.dataUri + "?only-deleted=";
    if (onlyDeleted !== undefined && onlyDeleted !== null) {
      uri += onlyDeleted;
    } else {
      uri += "false"
    }

    if (tagFilter !== undefined && tagFilter !== null && tagFilter.length > 0) {
      tagFilter.forEach(element => {
        uri += "&tag=" + element.value
      });
    }

    for (var sort of sorts) {
      uri += "&sort-field=" + sort.dataField;
      uri += "&sort-direction=" + (sort.order === 'asc');
    }

    if (searchTextFilter.size > 0) {
      const searchObjParams = [];
      for (var value of searchTextFilter.values()) {
        searchObjParams.push(value);
      }

      uri += "&filter-operation=" + encodeURIComponent(JSON.stringify(searchObjParams));
      uri += "&operation=" + searchOperation;
    }

    uri += "&page=" + (this.options.page - 1);
    uri += "&page-size=" + this.options.sizePerPage;

    this.setState({
      isLoading: true,
    });

    Http.getData(uri).then(response => {
      let pageTotal = response.headers["pagination-total"];
      this.options.totalSize = parseInt(pageTotal);
      this.options.page = 1;

      this.setState({
        records: response.data,
      });

      this.options.page = parseInt(sessionStorage.getItem(PowerGrid.pageStorageKey())) || 1;
      this.setState({
        isLoading: false,
      });

      this.props.onDataLoaded && this.props.onDataLoaded(response.data);
    });
  }

  updateRowState(row) {
    this.setState({
      records: this.state.records.map(r => r.id === row.id ? row : r)
    });
  }

  getDetailUri(suffix, revision) {
    let uri = (this.props.detailUri || this.props.dataUri) + "/" + suffix;
    if (this.state.onlyDeleted) {
      uri += "?deleted&revision=" + revision;
    }
    return uri;
  }

  searchActions() {
    let result = []
    if (this.props.search && !this.props.disableSearchBar) {
      result.push({
        render: (index) => (
          <SearchBar
            searchText={this.search.searchText}
            key={index}
            className="powergrid-search-input"
            onSearch={(searchText) => {
              this.onSearch(searchText); //then, execute the search to filter the table
            }}
            ref={this.searchBar} />)
      });
    }
    return result;
  }

  onSearch = (searchText) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      this.actionOnSearchText(searchText);
    }, 1000);
  }

  actionOnSearchText(searchText) {
    this.resetPages();

    sessionStorage.setItem(PowerGrid.searchStorageKey(), searchText);
    this.search.searchText = searchText;

    this.search.searchTextFilter.set('name', { key: 'name', operation: 'regex', value: searchText });
    this.search.searchTextFilter.set('description', { key: 'description', operation: 'regex', value: searchText });

    this.loadData();
  }

  toolbarItems() {
    let result = []
    if (this.props.toolbarActions !== undefined) {
      result = result.concat(this.props.toolbarActions);
    }
    if (this.props.canAdd && !this.state.onlyDeleted && this.props.canEdit) {
      result.push({ render: (index) => (<NavButton key={index} to={this.getDetailUri('new')} color="primary">New</NavButton>) });
    }
    return result;
  }

  rowDoubleClickAction(row, rowIndex) {
    if (this.props.keyField) {
      let uri = this.getDetailUri(row[this.props.keyField], row.revision);
      this.props.history.push(uri);
    }
  }

  toggleDeletedAction = (event) => {
    DataGrid.setSwitchDeleted(event.currentTarget.checked);
    this.setState({
      onlyDeleted: event.currentTarget.checked
    });

    this.resetPages();
    this.loadData();
  }

  resetPages() {
    this.options.page = 1;
    this.options.totalSize = 0;

    sessionStorage.setItem(PowerGrid.pageStorageKey(), this.options.page);
  }

  restore = (row) => {
    const path = `${this.props.dataUri}/${row.id}/restore?revision=${row.revision}`;
    Http.post(path).then(data => {
      let nRecords = [...this.state.records];
      let index = nRecords.findIndex(item => item.id === data.id);
      nRecords.splice(index, 1);
      this.setState({
        records: nRecords
      })
    });
  }

  getRowActions() {
    let result = [];

    if (this.props.exclusiveActions) {
      result.push(...this.props.exclusiveActions);
    } else {
      if (this.state.onlyDeleted) {
        result.push({ render: (row, index) => (<NavButton key={index} to={this.getDetailUri(row[this.props.keyField], row.revision)} size="sm" color="ghost-primary">View</NavButton>) });
        result.push({ render: (row, index) => (<Button key={index} onClick={() => this.restore(row)} size="sm" color="ghost-primary">Restore</Button>) });
      } else {
        result.push({
          render: (row, index) => (
            <NavButton key={index} to={this.getDetailUri(row[this.props.keyField])} size="sm" color="ghost-primary">
              {this.props.detailButtonLabel
                ? this.props.detailButtonLabel
                : this.props.canEdit
                  ? "Edit" : "View"}
            </NavButton>
          )
        });
      }

      if (!this.state.onlyDeleted) {
        if (this.props.canCopy) {
          result.push({ render: (row, index) => (<NavButton key={index} to={this.getDetailUri(row[this.props.keyField] + '?action=copy')} size="sm" color="ghost-primary">Copy</NavButton>) });
        }
        if (this.props.canExport) {
          result.push({ render: (row, index) => (<Button key={index} onClick={() => { this.addToExport(row) }} size="sm" color="ghost-primary">Add to export</Button>) });
        }
      }
    }

    if (this.props.rowActions) {
      result.push(...this.props.rowActions);
    }
    return result;
  }

  addToExport(row) {
    Export.add(this.props.dataUri, row);
    toast.success('Added to export!');
  }

  static clearStorageCache() {
    sessionStorage.removeItem('datagrid-switch-deleted');
  }

  static setSwitchDeleted(value) {
    sessionStorage.setItem('datagrid-switch-deleted', value);
  }

  static getSwitchDeleted() {
    let switchDeleted = sessionStorage.getItem('datagrid-switch-deleted');
    if (switchDeleted !== undefined && switchDeleted !== null) {
      return switchDeleted === "true";
    }
    return null;
  }

  leftToolbarItems() {
    let result = [];
    if (this.props.showDeletedSwitch) {
      result.push({
        render: (row, index) => (
          <Col key={'show_deleted_' + index} className="text-left">
            <AppSwitch className="mx-1 align-middle" color="danger" checked={this.state.onlyDeleted} onChange={this.toggleDeletedAction} />
            <Label className="pl-2">Show only deleted</Label>
          </Col>
        )
      });
    }
    return result;
  }

  onOwnSizePerPageChange(sizePerPage, page) {
    page = 1; // reset page for recalculate new size

    sessionStorage.setItem(PowerGrid.pageStorageKey(), page);
    localStorage.setItem(PowerGrid.sizePageStorageKey(), sizePerPage);

    this.options.page = page;
    this.options.sizePerPage = sizePerPage;

    this.loadData();
  }

  getLastPage() {
    const lastPage = this.options.totalSize / this.options.sizePerPage;
    return (this.options.totalSize % this.options.sizePerPage) === 0 ? parseInt(lastPage) : parseInt(lastPage) + 1;
  }

  onOwnPageChange(newPage, sizePerPage) {
    if (typeof newPage === 'string') {
      switch (newPage) {
        case 'First':
          newPage = 1;
          break;
        case 'Back':
          newPage = this.options.page === 1 ? 1 : this.options.page - 1;
          break;
        case 'Next':
          const lastPage = this.getLastPage();
          newPage = this.options.page === lastPage ? lastPage : this.options.page + 1;
          break;
        case 'Last':
          newPage = this.getLastPage();
          break;
        default:
          newPage = 1;
          console.log('Sorry, we are out of page.');
      }
    }

    // prevent unnecessary load data grid
    if (this.options.page === newPage) return;

    sessionStorage.setItem(PowerGrid.pageStorageKey(), newPage);
    localStorage.setItem(PowerGrid.sizePageStorageKey(), sizePerPage);

    this.options.page = newPage;
    this.options.sizePerPage = sizePerPage;

    this.loadData();
  }

  async ownPageButtonRenderer() {
    const pageListRenderer = ({
      pages,
      onPageChange
    }) => {
      let start = 1;
      if (this.options.page === this.getLastPage()) {
        start = this.getLastPage() <= this.options.paginationSize ? 1 : this.options.page - this.options.paginationSize + 1;
      } else if (this.options.page >= this.options.paginationSize) {
        start = this.options.page - this.options.paginationSize + 2;
      } else if (this.options.page <= this.options.paginationSize) {
        start = 1;
      }

      const newPages = [];
      newPages.push({ active: false, disabled: false, page: "First", title: "First page" });
      newPages.push({ active: false, disabled: false, page: "Back", title: "Back page" });
      for (var i = start; i <= this.getLastPage(); i++) {
        newPages.push({
          active: false,
          disabled: false,
          page: i,
          title: "Page " + i
        });
      }

      const maxRangePaged = newPages.slice(0, this.getLastPage() <= this.options.paginationSize ? newPages.length : this.options.paginationSize + 2); // ignoring string 
      maxRangePaged.push({ active: false, disabled: false, page: "Next", title: "Next page" });
      maxRangePaged.push({ active: false, disabled: false, page: "Last", title: "Last page" });

      const pageWithIndication = maxRangePaged;
      const buttonStyle = {
        margin: '1px',
      };
      return (
        <div className="react-bootstrap-table-pagination-list col-md-6 col-xs-6 col-sm-6 col-lg-6">
          <ul className="pagination react-bootstrap-table-page-btns-ul">
            {
              pageWithIndication.map(p => (
                <Button
                  key={'id' + p.page}
                  color="primary"
                  active={p.page === this.options.page}
                  aria-pressed="true"
                  outline
                  block
                  onClick={() => this.onOwnPageChange(p.page, this.options.sizePerPage)}
                  style={buttonStyle}>
                  {p.page}
                </Button>
              ))
            }
          </ul>
        </div>
      );
    };
    this.options.pageListRenderer = pageListRenderer;

    const customTotal = (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total">
        &nbsp;Showing {((this.options.page - 1) * this.options.sizePerPage) + 1}
        &nbsp;to {((this.options.page - 1) * this.options.sizePerPage) + this.state.records.length}
        &nbsp;of {this.options.totalSize} Results
      </span>
    );
    this.options.paginationTotalRenderer = customTotal;
  }

  paginationOptions() {
    if (this.options.totalSize > 0) {
      this.ownPageButtonRenderer();
      return paginationFactory(this.options);
    }
    return null;
  }

  render() {

    return (
      <PowerGrid
        {...this.props}
        data={this.state.records}
        toolbarActions={this.toolbarItems()}
        leftToolbarActions={this.leftToolbarItems()}
        rowDoubleClickAction={this.rowDoubleClickAction.bind(this)}
        rowActions={this.getRowActions()}
        paginationOptions={this.paginationOptions()}
        searchActions={this.searchActions()}
      />
    );
  }
}

DataGrid.propTypes = {
  ...PowerGrid.propTypes,
  dataUri: PropTypes.string.isRequired,
  detailUri: PropTypes.string,
  canAdd: PropTypes.bool,
  canCopy: PropTypes.bool,
  canExport: PropTypes.bool,
  canEdit: PropTypes.bool,
  search: PropTypes.bool,
  detailButtonLabel: PropTypes.string,
  showDeletedSwitch: PropTypes.bool,
  filter: PropTypes.array,
  onDataLoaded: PropTypes.func,
  exclusiveActions: PowerGrid.propTypes.rowActions
}

DataGrid.defaultProps = {
  canAdd: true,
  canCopy: false,
  canEdit: true,
  canExport: false,
  showDeletedSwitch: false,
  filter: null,
  onDataLoaded: null,
  detailButtonLabel: null,
  exclusiveActions: null,
  search: true,
  disableSearchBar: false,
}

export default withRouter(DataGrid);
